<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>媒体专访</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="publish_main">
            <p>奇点大课现场直击“科技驱动未来”</p>

            <p class="book_p">
                内容介绍
            </p>

            <p class="con_p">
                中信·奇点学院近期走访了多个成功的科技双创项目负责人，他们都给出了坚定的回答：“未来，必然是科技与商业共舞”。
                因此，5月奇点大课邀请3位顶尖科技创新大神走进奇点课堂倾授经验、为科技变现指点迷津。 
                科学家里最创新的创业者马兆远，以35岁裸辞中科院的勇气、转战创投圈一路走来鲜活的实战经验，传授科技产业化的基本路径。
                他的演讲题目为《科技创新：中国的未来》。他认为，工业4.0时代，个性化生产的成本比批量化生产的成本更低，生产越来越需要满足人的个性化需求。
            </p>

            <div class="video-com">
                <!-- <embed src="http://static.video.qq.com/TPout.swf?vid=i140086cvbf&amp;auto=0" 
                allowfullscreen="true" quality="high" width="700" height="450" align="middle" 
                allowscriptaccess="always" type="application/x-shockwave-flash"> -->

                <iframe height=450 width=700 src='http://player.youku.com/embed/XODE1NjE5NjI4' 
                frameborder=0>
                </iframe>
                
            </div>

        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }
 

/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.publish_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 80px;
}
.publish_main p:nth-child(1) {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 73px;
}
.publish_main .con_p {
    font-size: 14px;
    text-indent: 2em;
    margin-bottom: 34px;
}
.publish_main img{
    display: block;
    margin: 0 auto;
    margin-bottom: 100px;
    margin-top: 100px;
}

.book_p {
    font-size: 24px;
    margin-bottom: 60px;
}

.video-com {
    width: 701px;
    height: 452px;
    margin: 0 auto;
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/news/coming/coming.vue